export const IMAGE_TYPES = {
  primaryImage: 'Main Asset photo',
  equipmentImage: 'Asset Photo',
  nameplatePhoto: 'Nameplate',
  installationPointImage: 'Installation Point',
};

export const IMAGE_TYPES_TOOLTIPS = {
  [IMAGE_TYPES.primaryImage]: 'Only one photo can be assigned as the Main Asset Photo, and it will appear across all installation point galleries.',
  [IMAGE_TYPES.equipmentImage]: 'A general asset photo. It displays on the Sensor List page but does not assign to any installation point.',
  [IMAGE_TYPES.nameplatePhoto]: 'A nameplate photo may be assigned to a specific installation point, multiple installation points, or the entire asset.',
  [IMAGE_TYPES.installationPointImage]: 'Photo of the sensor mounted on the asset. Assignable to only one installation point.',
}
